import { useMemo } from "react"

import useProductTotals from "@/hooks/useProductTotals"
import { PassHolderFormState } from "@/types/PassHolder"
import { formatCurrency } from "@/utils/priceUtils"

const useOrderTotal = (passHolders: PassHolderFormState[]) => {
  const { totalPrice: productTotal, selectedProducts } = useProductTotals()

  const totals = useMemo(() => {
    const { insuranceTotal, cardTotal } = passHolders.reduce(
      (totals, holder) => ({
        insuranceTotal: totals.insuranceTotal + (holder.insurancePrice ?? 0),
        cardTotal: totals.cardTotal + (holder.cardPrice ?? 0),
      }),
      { insuranceTotal: 0, cardTotal: 0 }
    )

    const orderTotal = productTotal + insuranceTotal + cardTotal

    return {
      orderTotal,
      orderTotalPriceText: formatCurrency(
        orderTotal,
        selectedProducts[0]?.priceSuffix
      ),
    }
  }, [productTotal, passHolders, selectedProducts])

  return totals
}

export default useOrderTotal
